import React from "react";
import { Checkbox, FormControlLabel, FormControl } from "@mui/material";

const CheckboxInput = ({ label, name, checked, onChange, required }) => {
  return (
    <FormControl
      required={required}
      sx={{
        display: "flex",
        justifyContent: "center",
        pl: 1,
        mt: 1,
        "& .MuiFormControlLabel-label": {
          fontFamily: "SFProDisplay-Regular, Helvetica, Arial, sans-serif",
          fontSize: "15px",
          color: "#1C1E21",
        },
        "& .MuiCheckbox-root.Mui-checked": {
          color: "#1877F2", // Facebook blue checkbox
        }
      }}
    >
      <FormControlLabel
        control={
          <Checkbox
            name={name}
            checked={!!checked}
            onChange={(e) => onChange({ target: { name, value: e.target.checked } })}
          />
        }
        label={label}
      />
    </FormControl>
  );
};

export default CheckboxInput;